import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { AbstractControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { SectionBase } from '../../../components/section/section-base';
import { PartyTypeCode } from '../../../../core/consts/party-type-code.enum';
import { OwnerDataStateService } from '../../../../core/services/impl/section-services/owner-data/owner-data-state.service';
import { FormConfig } from '../../../models/form-config';
import { FormFactoryService } from '../../../services/form-factory.service';
import { CoOwnerConfig } from './co-owner/co-owner.config';
import { OwnerDataConfig } from './owner-data.config';
import { OwnerModel } from '../../../../core/models/owner-data/owner.model';
import { OwnerDataInterface } from '../../../../core/services/api/sections-api/owner-data-interface';
import { isNullOrUndefined } from 'util';
import { OwnerDataConsts } from '../../../../core/consts/owner-data.consts';
import { PredefinedValuesService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import { PredefinedValuesStateService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values-state.service';
import { StepKey } from '../../../../core/enums/step-key.enum';
import { ScrollHelper } from '../../../services/scroll-helper';
import { AgreementsService } from '../../../services/agreements.service';
import { LanguageService } from '../../../services/language.service';
import { AdditionalDriverModel } from '../../../../core/models/owner-data/additional-driver.model';
import { AdditionalDriverConfig } from './additional-driver/additional-driver.config';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import {isNext, isMobile, isKIOSKPOLIS, isCarOne} from '../../../../core/utils/utils';
import {AssetsService} from '../../../services/assets.service';
import {getDrivingLicenseIssueMonths} from '../../../utils/driving-license-years';
import {FormFieldService} from '../../../services/form-field.service';
import * as moment from 'moment';
import {MaterialDatepickerComponent} from '../../../components/fields/datepickers/material-datepicker/material-datepicker.component';
import {PeselService} from '../../../services/pesel.service';
import {
  InitialDataStateService
} from '../../../../core/services/impl/section-services/initial-data/initial-data-state.service';
import {FieldsVisibilityService} from '../../../../core/services/fields-visibility.service';
import {RegExpService} from '../../../services/reg-exp.service';

@Component({
  selector: 'app-owner-data-section',
  templateUrl: './owner-data-section.component.html',
  styleUrls: ['./owner-data-section.component.scss']
})
export class OwnerDataSectionComponent extends SectionBase implements OnInit, AfterViewInit, OwnerDataInterface {

  @ViewChild('drivingLicenseIssueYearField') drivingLicenseIssueYearField: MaterialDatepickerComponent;

  readonly MAX_AMOUNT_CO_OWNERS: number = 5;

  public coOwnersList: Array<any>;
  public coOwnersFormArray: FormArray;
  public coOwnersFormServices: FormFactoryService[] = [];
  public coOwnerConfig: CoOwnerConfig = new CoOwnerConfig(this.predefined, this.stateService, this.regExpService);
  public amountCoOwners: number = 0;

  public additionalDriversList: Array<any>;
  public additionalDriversFormArray: FormArray;
  public additionalDriversFormServices: FormFactoryService[] = [];
  public additionalDriverConfig: AdditionalDriverConfig = new AdditionalDriverConfig(this.predefined, this.stateService);
  public amountAdditionalDrivers: number = 0;

  public partyTypeCode = PartyTypeCode;
  public config: OwnerDataConfig = new OwnerDataConfig(this.stateService, this.predefined, this.agreementsService, this.languageService, this.regExpService);

  public coOwnerButtonVisible: boolean = false;
  public drivingLicenseIssueMonthCollected: boolean = true;

  public consts = OwnerDataConsts;
  public dataPresentationFields: string[];
  isNext = isNext();
  isCarOne = isCarOne();
  verifyDataVisible = isKIOSKPOLIS();
  sectionClass = 'owner-data-section';
  ownerDataHintVisible: boolean = !isCarOne();

  private iconsDirectoryPath: string;

  ngOnInit() {
    this.initBean();
    this.initIsFieldDirtyBean();
    this.createConfig();
    this.buildForm();

    this.initAmountCoOwners();
    this.initAmountAdditionalDrivers();

    this.changePersonCharacter(this.stateService.partyTypeCode);
    this.showFieldsForPartyTypeCode(this.stateService.partyTypeCode);
    this.prepareFieldsInPreviewMode(this.stateService.partyTypeCode);

    this.initCoOwnersOption(this.stateService.coOwnersOption);
    this.initAdditionalDriversOption(this.stateService.additionalDriversOption);

    this.createCoOwnerFormGroups();
    this.createAdditionalDriverFormGroups();
    this.abilityToCreatingCoOwner(this.stateService.coOwnersOption);

    this.initControlsChanges();
    this.config.initDrivingLicenseIssueYears(this.stateService.ownerData.pesel, this.config.getConfig());
    this.updateDrivingLicenseFieldsState();
    this.updateDrivingLicenseIssueMonthState();
    this.initPostalCodeFieldValidity();
    this.handleBirthDateChange();
  }

  ngAfterViewInit() {
    this.validatePeselWithBirthDate(this.getControl(OwnerDataConsts.PESEL).value);
  }

  constructor(public stateService: OwnerDataStateService,
              private predefined: PredefinedValuesService,
              private languageService: LanguageService,
              private agreementsService: AgreementsService,
              private assetsService: AssetsService,
              private formFieldService: FormFieldService,
              private predefinedState: PredefinedValuesStateService,
              private initialDataStateService: InitialDataStateService,
              public fieldsVisibilityService: FieldsVisibilityService,
              private regExpService: RegExpService) {
    super();
    this.stateService.ownerDataSection = this;
    this.iconsDirectoryPath = this.assetsService.getIconsDirectoryPath();
  }

  get isNaturalPerson(): boolean {
    return this.stateService.partyTypeCode === this.partyTypeCode.NATURAL_PERSON;
  }

  get isOrganization(): boolean {
    return this.stateService.partyTypeCode === this.partyTypeCode.ORGANIZATION;
  }

  get isBusinessActivity(): boolean {
    return this.stateService.partyTypeCode === this.partyTypeCode.BUSINESS_ACTIVITY;
  }

  get showInformation(): boolean {
    return !this.previewMode;
  }

  get hasChildrenUnder26(): boolean {
    return this.getControl(this.consts.CHILDREN_UNDER_26).value;
  }

  get bulbIconSrc(): string {
    return `${this.iconsDirectoryPath}/bulb.png`;
  }

  get isMobile(): boolean {
    return isMobile();
  }

  get noDrivingLicenseVisible(): boolean {
    return !isCarOne() && !this.isOrganization && this.canFieldDisplayed(OwnerDataConsts.NO_DRIVING_LICENSE);
  }

  changePersonCharacter(partyTypeCode: string): void {
    this.getControl(this.consts.PARTY_CODE_TYPE).setValue(partyTypeCode);
  }

  initBean(): void {
    this.bean = {
      ...this.stateService.ownerData,
      ...this.stateService.ownerContactData,
      ...{
        agreements: this.stateService.onwerAgreements
      },
      additionalDrivers: this.stateService.additionalDrivers,
      noDrivingLicense: this.stateService.noDrivingLicense
    };
  }

  clearAppropriateValidator(partyTypeCode?: string): void {
    if (!isNullOrUndefined(partyTypeCode) && partyTypeCode === this.partyTypeCode.NATURAL_PERSON) {
      this.clearMultipleValidators(
        this.consts.NIP,
        this.consts.COMPANY_NAME
      );
    }
    if (!isNullOrUndefined(partyTypeCode) && partyTypeCode === this.partyTypeCode.ORGANIZATION) {
      this.clearMultipleValidators(
        this.consts.PESEL,
        this.consts.LAST_NAME,
        this.consts.FIRST_NAME,
        this.consts.BIRTH_DATE,
        this.consts.DRIVING_LICENSE_ISSUE_YEAR
      );
    }

    if (!isNullOrUndefined(partyTypeCode) && partyTypeCode === this.partyTypeCode.BUSINESS_ACTIVITY) {
      this.clearMultipleValidators(
        this.consts.BIRTH_DATE,
      );
    }
  }

  initAppropriateValidators(partyTypeCode: string): void {
    if (partyTypeCode === this.partyTypeCode.NATURAL_PERSON) {
      this.initControlsValidators(
        this.consts.FIRST_NAME,
        this.consts.LAST_NAME,
        this.consts.PESEL,
        this.consts.BIRTH_DATE,
        this.consts.DRIVING_LICENSE_ISSUE_YEAR,
      );
    }

    if (partyTypeCode === this.partyTypeCode.ORGANIZATION) {
      this.initControlsValidators(
        this.consts.COMPANY_NAME,
        this.consts.NIP
      );
    }

    if (partyTypeCode === this.partyTypeCode.BUSINESS_ACTIVITY) {
      this.initControlsValidators(
        this.consts.FIRST_NAME,
        this.consts.LAST_NAME,
        this.consts.COMPANY_NAME,
        this.consts.NIP,
        this.consts.PESEL,
        this.consts.DRIVING_LICENSE_ISSUE_YEAR,
      );
    }
  }

  resetAppropriateFields(partyTypeCode: string): void {
    if (partyTypeCode === this.partyTypeCode.NATURAL_PERSON) {
      this.resetMultipleControls(
        this.consts.NIP,
        this.consts.COMPANY_NAME
      );
    }
    if (partyTypeCode === this.partyTypeCode.ORGANIZATION) {
      this.resetMultipleControls(
        this.consts.PESEL,
        this.consts.LAST_NAME,
        this.consts.FIRST_NAME,
        this.consts.BIRTH_DATE,
        this.consts.DRIVING_LICENSE_ISSUE_YEAR
      );
    }
  }

  showFieldsForPartyTypeCode(partyTypeCode: string): void {
    this.clearAppropriateValidator(partyTypeCode);
    this.initAppropriateValidators(partyTypeCode);
    this.prepareFieldsInPreviewMode(partyTypeCode);
    this.updateValidityAfterValidatorsUpdate();

    setTimeout(() => {
    }, 0);
  }

  initControlsChanges(): void {
    this.handleControlsState(
      { controlName: this.consts.CO_OWNERS, behaviour: value => this.handleCoOwnersChange(value) },
      { controlName: this.consts.PARTY_CODE_TYPE, behaviour: value => this.handlePartyTypeCodeChange(value) },
      { controlName: this.consts.COMPANY_NAME, behaviour: value => this.stateService.changeCompanyName(value) },
      { controlName: this.consts.BIRTH_DATE, behaviour: value => this.stateService.changeBirthDate(value) },
      { controlName: this.consts.PESEL, behaviour: value => this.handlePeselChange(value) },
      { controlName: this.consts.NIP, behaviour: value => this.stateService.changeNIP(value) },
      { controlName: this.consts.LAST_NAME, behaviour: value => this.stateService.changeLastName(value) },
      { controlName: this.consts.FIRST_NAME, behaviour: value => this.stateService.changeFirstName(value) },
      { controlName: this.consts.POSTAL_CODE, behaviour: value => this.changePostalCode(value) },
      { controlName: this.consts.MATRIMONIAL_STATUS, behaviour: value => this.stateService.changeMatrimonialStatus(value) },
      { controlName: this.consts.CHILDREN_UNDER_26, behaviour: value => {
        if (value) {
          this.getControl(this.consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH).setValidators([Validators.required]);
        } else {
          this.getControl(this.consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH).reset();
          this.getControl(this.consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH).clearValidators();
        }
        this.getControl(this.consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH).updateValueAndValidity();

        this.stateService.changeChildrenUnder26(value);
      }
        },
      { controlName: this.consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH, behaviour: value => {
          value = moment(value).year();
          this.stateService.changeOldestYoungChildYearOfBirth(value);
        }
      },
      {
        controlName: this.consts.DRIVING_LICENSE_ISSUE_YEAR,
        behaviour: value => {
          if (isNotNullOrUndefined(value) && this.getControl(this.consts.NO_DRIVING_LICENSE).value) {
            this.getControl(this.consts.NO_DRIVING_LICENSE).setValue(false);
          }
          value = moment(value).year();
          this.stateService.changeDrivingLicenseIssueYear(value);
          this.updateDrivingLicenseIssueMonthState();
        }
      },
      {
        controlName: this.consts.NO_DRIVING_LICENSE,
        behaviour: value => {
          this.stateService.changeNoDrivingLicense(value);
          this.updateDrivingLicenseFieldsState()
        }
      },
      { controlName: this.consts.DRIVING_LICENSE_ISSUE_MONTH, behaviour: value => this.stateService.changeDrivingLicenseIssueMonth(value) },
      { controlName: this.consts.ADDITIONAL_DRIVERS, behaviour: value => this.handleAdditionalDriversChange(value)},
    );
  }

  createCoOwnerFormGroups(): void {
    this.coOwnersReset();
    for (let i = 0; i < this.amountCoOwners; i++) {
      let coOwnerForm = new FormGroup({});
      let coOwnerFromBean;
      if (!isNullOrUndefined(this.bean.coOwners[i])) {
        coOwnerFromBean = {
          ...this.bean.coOwners[i],
          ...this.stateService.coOwnersState[i]
        };
      }

      let coOwnerConfig: FormConfig = JSON.parse(JSON.stringify(this.coOwnerConfig.createCoOwnerConfig()));
      let formService;
      if (coOwnerFromBean) {
        formService = new FormFactoryService(coOwnerConfig, coOwnerFromBean);
      } else {
        formService = new FormFactoryService(coOwnerConfig);
      }
      formService.buildFormGroup(coOwnerForm);

      if (this.bean.coOwners[i]) {
        this.coOwnersUpdate(this.bean.coOwners[i], coOwnerForm, formService);
      } else {
        this.coOwnersUpdate(new OwnerModel(), coOwnerForm, formService);
      }
    }
  }

  createAdditionalDriverFormGroups(): void {
    this.resetAdditionalDrivers();
    for (let i = 0; i < this.amountAdditionalDrivers; i++) {
      let driverForm = new FormGroup({});
      let driverFromBean;
      if (!isNullOrUndefined(this.bean.additionalDrivers[i])) {
        driverFromBean = this.bean.additionalDrivers[i];
      }

      let driverConfig: FormConfig = JSON.parse(JSON.stringify(this.additionalDriverConfig.createAdditionalDriverConfig()));
      let formService;
      if (driverFromBean) {
        formService = new FormFactoryService(driverConfig, driverFromBean);
      } else {
        formService = new FormFactoryService(driverConfig);
      }
      formService.buildFormGroup(driverForm);

      if (this.bean.additionalDrivers[i]) {
        this.additionalDriversUpdate(this.bean.additionalDrivers[i], driverForm, formService);
      } else {
        this.additionalDriversUpdate(new AdditionalDriverModel(), driverForm, formService);
      }
    }
  }

  createCoOwnerForm(newCoOwner: OwnerModel): void {
    let coOwnerForm = new FormGroup({});
    let coOwnerConfig: FormConfig = JSON.parse(JSON.stringify(this.coOwnerConfig.createCoOwnerConfig()));
    let formService = new FormFactoryService(coOwnerConfig, newCoOwner);
    formService.buildFormGroup(coOwnerForm);

    this.coOwnersUpdate(new OwnerModel(), coOwnerForm, formService);
  }
  
  createAdditionalDriverForm(driver: AdditionalDriverModel): void {
    const form = new FormGroup({});
    const config: FormConfig = JSON.parse(JSON.stringify(this.additionalDriverConfig.createAdditionalDriverConfig()));
    const formService = new FormFactoryService(config, driver);
    formService.buildFormGroup(form);

    this.additionalDriversUpdate(new AdditionalDriverModel(), form, formService);
  }

  createConfig(): void {
    this.formConfig = this.config.createOwnerConfig();
  }

  removeCoOwners(): void {
    this.coOwnersReset();
    this.stateService.updateCoOwners(this.coOwnersList);
    this.stateService.clearCoOwnersState();
  }

  removeAdditionalDrivers(): void {
    this.resetAdditionalDrivers();
    this.stateService.updateAdditionalDrivers(this.additionalDriversList);
  }

  removeCoOwner(index: number): void {
    if (this.coOwnersList.length > 1) {
      this.coOwnersFormArray.removeAt(index);
      this.coOwnersList.splice(index, 1);
      this.coOwnersFormServices.splice(index, 1);
      this.amountCoOwners--;

      this.stateService.updateCoOwners(this.coOwnersList);
    }
  }

  createCoOwner(amount?: number): void {
    if (!isNullOrUndefined(amount) && amount > 0) {
      for (let i = 0; i < amount; i++) {
        this.addCoOwner();
      }
    } else if (isNullOrUndefined(amount)) {
      this.addCoOwner();
    }
  }

  createAdditionalDrivers(amount: number): void {
    for (let i = 0; i < amount; i++) {
      this.addAdditionalDriver();
    }
  }

  fillForm(data: any) {
    super.fillForm(data);
    if (data.stepKey === StepKey.FIRST_STEP_3) {
      let control, key, value;
      const coOwnersAmount = this.sectionDataMock.coOwners;
      const sectionDataMock = this.sectionDataMock;
      for (let i = 0; i < coOwnersAmount; i++) {
        this.sectionDataMock = sectionDataMock.coOwnersData[i];
        this.coOwnersFormServices[i].formConfig.fieldsConfig.forEach(fieldConfig => {
          key = fieldConfig.fieldKey;
          control = this.getControlFromCoOwner(key, i);
          value = this.getMockValue(key);
          if (!isNullOrUndefined(value)) {
            control.setValue(value);
          }
        });
      }
      if (coOwnersAmount) {
        this.stateService.updateCoOwners(sectionDataMock.coOwnersData);
      }
      setTimeout(() => (new ScrollHelper).scrollToBottom(), 0);
    }
  }

  getControlFromCoOwner(key: string, index: number): AbstractControl {
    return this.coOwnersFormArray.at(index)['controls'][key];
  }

  public isSectionValid(): boolean {
    let subsectionsValid = this.coOwnersFormServices.map(factory => factory.formGroup.valid).every(valid => valid);

    if (subsectionsValid) { // coowners subsection is valid - check additonal drivers subsection
      subsectionsValid = this.additionalDriversFormServices.map(factory => factory.formGroup.valid).every(valid => valid);
    }

    return subsectionsValid && super.isSectionValid();
  }

  public submitSection(): void {
    this.coOwnersFormServices.forEach(factory => factory.submitForm());
    this.additionalDriversFormServices.forEach(factory => factory.submitForm());

    super.submitSection();
    if (this.isSectionValid()) {
      this.resetAppropriateFields(this.stateService.partyTypeCode);
    }
  }

  onStepSubmitted(stepValidity: boolean): void {
    if (stepValidity && !this.formFieldService.fieldClickEventSent(this.getFieldConfig(OwnerDataConsts.CHILDREN_UNDER_26))) {
      this.sendChildrenUnder26ClickEvent();
    }
  }

  isFieldVisible(fieldKey: string): boolean {
    return this.canFieldDisplayed(fieldKey) && this.fieldsVisibilityService.isFieldVisible('OWNER_DATA_SECTION', fieldKey);
  }

  public areErrors(): boolean {
    if (!isNullOrUndefined(this.coOwnersFormServices)) {
      let areErrors = super.areErrors();
      let errorsCount = areErrors ? 1 : 0;

      this.coOwnersFormServices.forEach(factory => {
        if (factory.errorsMap.size !== 0) {
          errorsCount++;
        }
      });
      return errorsCount !== 0;
    }
    return false;
  }

  public changeNIP(nip: string): void {
  }

  public changePesel(pesel: string): void {
  }

  public changeCoOwners(coOwner: number): void {
  }

  public changeLastName(lastName: string): void {
  }

  public changeFirstName(firstName: string): void {
  }

  public changeBirthDate(companyName: Date): void {
  }

  public changeCompanyName(companyName: string): void {
  }

  public changePartyTypeCode(partyTypeCode: string): void {
  }

  public changeDrivingLicenseIssueYear(drivingLicenseIssueYear: number): void {
  }

  markAsDirty(event) {
    this.predefinedState.isDirtyBean = event;
  }

  async changePostalCode(postalCode: string) {
    this.stateService.changePostalCode(postalCode);
    await this.validatePostalCode(postalCode);
  }

  private initPostalCodeFieldValidity() {
    const postalCode = this.formGroup.controls[this.consts.POSTAL_CODE].value;
    this.validatePostalCode(postalCode);
  }

  private initIsFieldDirtyBean() {
    this.isDirtyBean = this.predefinedState.isDirtyBean;
  }

  private handleBirthDateChange(): void {
    this.initialDataStateService.birthDateChange$.subscribe(() => {
      this.validatePeselWithBirthDate(this.getControl(OwnerDataConsts.PESEL).value);
      this.getControl(OwnerDataConsts.PESEL).updateValueAndValidity();
    });
  }

  private handlePeselChange(value: string) {
    this.stateService.changePesel(value);
    this.validatePeselWithBirthDate(value);
    this.config.updateOptionsOnValidPesel(value, this.config.getConfig());
    if (isNotNullOrUndefined(this.drivingLicenseIssueYearField)) {
      this.drivingLicenseIssueYearField.initDateRange();
    }
    this.config.resetAndSetPreviousPeselValue(value, this.formGroup);
  }

  private validatePeselWithBirthDate(value: string): void {
    if (isNotNullOrUndefined(value) && value.length === 11) {
      const peselBirthDate = PeselService.getBirthdate(value);
      const peselErrors = this.getControl(OwnerDataConsts.PESEL).errors;
      if (moment(this.stateService.ownerData.birthDate).isSame(peselBirthDate, 'day')) {
        this.getControl(OwnerDataConsts.PESEL).setErrors(peselErrors);
      } else {
        this.getControl(OwnerDataConsts.PESEL).setErrors({'birthDateNotMatching': true});
        this.getControl(OwnerDataConsts.PESEL).markAsTouched();
      }
    }
  }

  private handleCoOwnersChange(value) {
    this.removeCoOwners();
    this.createAppropriateCoOwnersForms(value);
  }

  private handleAdditionalDriversChange(value) {
    this.removeAdditionalDrivers();
    this.createAdditionalDrivers(value);
  }

  private handlePartyTypeCodeChange(value) {
    this.stateService.changePartyTypeCode(value);
    this.showFieldsForPartyTypeCode(value);
  }

  private coOwnersUpdate(coOwnersList, coOwnersFormArray, coOwnersFormServices): void {
    this.coOwnersList.push(coOwnersList);
    this.coOwnersFormArray.push(coOwnersFormArray);
    this.coOwnersFormServices.push(coOwnersFormServices);
  }

  private additionalDriversUpdate(list, formArray, formServices): void {
    this.additionalDriversList.push(list);
    this.additionalDriversFormArray.push(formArray);
    this.additionalDriversFormServices.push(formServices);
  }

  private coOwnersReset(): void {
    this.coOwnersList = [];
    this.coOwnersFormServices = [];
    this.coOwnersFormArray = new FormArray([]);
  }

  private resetAdditionalDrivers(): void {
    this.additionalDriversList = [];
    this.additionalDriversFormServices = [];
    this.additionalDriversFormArray = new FormArray([]);
  }

  private createAppropriateCoOwnersForms(value): void {
    this.createCoOwner(value);
    this.abilityToCreatingCoOwner(value);
  }

  private initAmountCoOwners() {
    this.amountCoOwners = this.bean.coOwners ? this.bean.coOwners.length : 0;
  }

  private initAmountAdditionalDrivers() {
    this.amountAdditionalDrivers = this.bean.additionalDrivers ? this.bean.additionalDrivers.length : 0;
  }

  private abilityToCreatingCoOwner(value: number): void {
    if (value === 2) {
      this.coOwnerButtonVisible = true;
    } else {
      this.coOwnerButtonVisible = false;
    }
  }

  private addCoOwner(): void {
    if (this.coOwnersList.length < this.MAX_AMOUNT_CO_OWNERS) {
      let newCoOwner = new OwnerModel();
      this.createCoOwnerForm(newCoOwner);
      this.amountCoOwners++;

      this.stateService.updateCoOwners(this.coOwnersList);
      this.stateService.addCoOwnerToState();
    }
  }

  private addAdditionalDriver(): void {
    const driver = new AdditionalDriverModel();
    this.createAdditionalDriverForm(driver);
    this.amountAdditionalDrivers++;
    this.stateService.updateAdditionalDrivers(this.additionalDriversList);
  }

  private initCoOwnersOption(coOwnersOption: number): void {
    this.getControl(this.consts.CO_OWNERS).setValue(coOwnersOption);
  }

  private initAdditionalDriversOption(additionalDriversOption: number): void {
    this.getControl(this.consts.ADDITIONAL_DRIVERS).setValue(additionalDriversOption);
  }

  private updateDrivingLicenseIssueMonthState(): void {
    const drivingLicenseIssueYear = this.stateService.ownerData.drivingLicenseIssueYear;

    if (this.stateService.noDrivingLicense || !this.stateService.shouldCollectDrivingLicenseIssueMonth(this.stateService.ownerData.drivingLicenseIssueYear)) {
      this.disableCollectingDrivingLicenseIssueMonth();
    } else {
      this.enableCollectingDrivingLicenseIssueMonth();
    }

    if (this.drivingLicenseIssueMonthCollected) {
      const items = getDrivingLicenseIssueMonths(drivingLicenseIssueYear);
      this.getFieldConfig(this.consts.DRIVING_LICENSE_ISSUE_MONTH).options['items'] = items;
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).setValidators([Validators.required]);

      // validate existing value
      const month = this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).value;
      if (isNotNullOrUndefined(month) && !items.find(item => item.key === month)) { // month is defined but it doesn't exist in current dictionary
        this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).reset();
      }
    } else {
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).reset();
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).clearValidators();
    }
    this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).updateValueAndValidity();
  }

  private updateValidityAfterValidatorsUpdate(): void {
    this.updateValueAndValidity(
      this.consts.FIRST_NAME,
      this.consts.LAST_NAME,
      this.consts.PESEL,
      this.consts.BIRTH_DATE,
      this.consts.DRIVING_LICENSE_ISSUE_YEAR,
      this.consts.POSTAL_CODE,
      this.consts.NIP,
      this.consts.COMPANY_NAME
    );
  }

  private prepareFieldsInPreviewMode(partyTypeCode: string) {
    switch (partyTypeCode) {
      case this.partyTypeCode.NATURAL_PERSON:
        this.dataPresentationFields = [
          this.consts.PARTY_CODE_TYPE,
          this.consts.LAST_NAME,
          this.consts.FIRST_NAME,
          this.consts.PESEL,
          this.consts.POSTAL_CODE,
          this.consts.CO_OWNERS,
          this.consts.ADDITIONAL_DRIVERS,
          this.consts.CHILDREN_UNDER_26];
        break;
      case this.partyTypeCode.BUSINESS_ACTIVITY:
        this.dataPresentationFields = [
          this.consts.PARTY_CODE_TYPE,
          this.consts.LAST_NAME,
          this.consts.FIRST_NAME,
          this.consts.PESEL,
          this.consts.POSTAL_CODE,
          this.consts.CO_OWNERS,
          this.consts.NIP,
          this.consts.COMPANY_NAME,
          this.consts.ADDITIONAL_DRIVERS,
          this.consts.CHILDREN_UNDER_26];
        break;
      case this.partyTypeCode.ORGANIZATION:
        this.dataPresentationFields = [
          this.consts.NIP,
          this.consts.COMPANY_NAME,
          this.consts.POSTAL_CODE
        ];
        break;
    }

    // add dynamic fields only if their values exists
    if (!this.isOrganization) {
      if (this.hasChildrenUnder26) {
        this.dataPresentationFields.push(this.consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH);
      }
      if (this.stateService.ownerData.drivingLicenseIssueYear) {
        this.dataPresentationFields.push(this.consts.DRIVING_LICENSE_ISSUE_YEAR);
      }
      if (this.stateService.ownerData.drivingLicenseIssueMonth) {
        this.dataPresentationFields.push(this.consts.DRIVING_LICENSE_ISSUE_MONTH);
      }
      if (this.stateService.ownerData.matrimonialStatus) {
        this.dataPresentationFields.push(this.consts.MATRIMONIAL_STATUS);
      }
    }
  }

  private updateDrivingLicenseFieldsState(): void {
    if (this.stateService.noDrivingLicense) {
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_YEAR).reset(null);
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_YEAR).clearValidators();

      this.disableCollectingDrivingLicenseIssueMonth();
    } else {
      if (isNotNullOrUndefined(this.getControl(this.consts.DRIVING_LICENSE_ISSUE_YEAR))) {
        this.getControl(this.consts.DRIVING_LICENSE_ISSUE_YEAR).setValidators([Validators.required]);
      }

      if (this.stateService.shouldCollectDrivingLicenseIssueMonth(this.stateService.ownerData.drivingLicenseIssueYear)) {
        this.enableCollectingDrivingLicenseIssueMonth();
      } else {
        this.disableCollectingDrivingLicenseIssueMonth();
      }
    }

    if (isNotNullOrUndefined(this.getControl(this.consts.DRIVING_LICENSE_ISSUE_YEAR))) {
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_YEAR).updateValueAndValidity();
    }
    if (isNotNullOrUndefined(this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH))) {
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).updateValueAndValidity();
    }
  }

  private disableCollectingDrivingLicenseIssueMonth(): void {
    this.drivingLicenseIssueMonthCollected = false;
    if (isNotNullOrUndefined(this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH))) {
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).reset(null);
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).clearValidators();
    }
  }

  private enableCollectingDrivingLicenseIssueMonth(): void {
    this.drivingLicenseIssueMonthCollected = true;
    if (isNotNullOrUndefined(this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH))) {
      this.getControl(this.consts.DRIVING_LICENSE_ISSUE_MONTH).setValidators([Validators.required]);
    }
  }

  private async validatePostalCode(postalCode: string) {
    if (postalCode.length === 6) {
      const isValid = await this.stateService.validatePostalCode(postalCode);
      if (isValid) {
        this.getControl(this.consts.POSTAL_CODE).setErrors(null);
      } else {
        this.getControl(this.consts.POSTAL_CODE).setErrors({'nonexistentPostalCode': true});
        this.getControl(this.consts.POSTAL_CODE).markAsTouched();
      }
    }
  }

  private sendChildrenUnder26ClickEvent(): void {
    this.formFieldService.onClick(this.getFieldConfig(this.consts.CHILDREN_UNDER_26), this.getControl(this.consts.CHILDREN_UNDER_26).value);
  }
}
